import {connect} from 'react-redux';
import FundLevelReportDashboard from '../components/FundLevelReportDashboard';

// import {loadCountryCodesSuccess} from '../../../../views/features/home/homeActions';


import {
  loadExchangeCode,
  initLoadExchangeCodeActionStatus,
  
  // Generate Fund Level Report
  generateFundLevelReport,
  initGenerateFundLevelReportActionStatus,

  // Load Fund Level Report
  loadFundLevelReport,
  initLoadFundLevelReportActionStatus,

  // load group info
  listFundPosGroupInfo,
  initListFundPosGroupInfoActionStatus,
  
  // Filter Long More Than 2% Fund Level Report
  filterLongMoreThan2PercentFundLevelReport,

  // Filter Long More Than 5% Fund Level Report
  filterLongMoreThan5PercentFundLevelReport,

  // Filter Short More Than 2% Fund Level Report
  filterShortMoreThan2PercentFundLevelReport,

  // Filter Short More Than 5% Fund Level Report
  filterShortMoreThan5PercentFundLevelReport,

  // Show All Fund Level Report
  showAllFundLevelReport,

  // add grid to container
  fundPositionGroupInfoGridToProps,
  fundLevelReportGridToProps,


} from '../fundLevelReportActions';

const mapStateToProps = state => {
  return {
    countryCodeOptions: state.fundLevelReport.countryCodeOptions,
     // Load Exchange Code
    loadExchangeCodeActionStatus: state.fundLevelReport.loadExchangeCodeActionStatus,
    exchageCodeArray: state.fundLevelReport.exchageCodeArray,
    exchageCodeOptions: state.fundLevelReport.exchageCodeOptions,
    // Grdi Columns
    gridType: state.fundLevelReport.gridType,
    fundLevelReportGridColumns: state.fundLevelReport.fundLevelReportGridColumns,
    fundPositionGroupInfoGridColumns: state.fundLevelReport.fundPositionGroupInfoGridColumns,

    // Fund Level Report
    fundLevelReportArray: state.fundLevelReport.fundLevelReportArray,
    filterFundLevelReportArray: state.fundLevelReport.filterFundLevelReportArray,

    // Generate Fund Level Report Action Status
    generateFundLevelReportActionStatus: state.fundLevelReport.generateFundLevelReportActionStatus,
    generateFundLevelReportErrMsg: state.fundLevelReport.generateFundLevelReportErrMsg,

    // Load Fund Level Report Action Status
    loadFundLevelReportActionStatus: state.fundLevelReport.loadFundLevelReportActionStatus,
    loadFundLevelReportErrMsg: state.fundLevelReport.loadFundLevelReportErrMsg,

    // Load Fund Level Report
    listFundPosGroupInfoActionStatus: state.fundLevelReport.listFundPosGroupInfoActionStatus,
    listFundPosGroupInfoActionResp: state.fundLevelReport.listFundPosGroupInfoActionResp,

    // add grid to container
    fundPositionGroupInfoGrid: state.fundLevelReport.fundPositionGroupInfoGrid,
    fundLevelReportGrid: state.fundLevelReport.fundLevelReportGrid,

  };
} 

const mapDispatchToProps = dispatch => {
  return {
    loadExchangeCode: (queryText) => dispatch(loadExchangeCode(queryText)),
    initLoadExchangeCodeActionStatus: () => dispatch(initLoadExchangeCodeActionStatus()),
    
    // Generate Fund Level Report
    generateFundLevelReport: (dateString, countryDesc, exchange, fundCode, dataType, qtyType) => dispatch(generateFundLevelReport(dateString, countryDesc, exchange, fundCode, dataType, qtyType)),
    initGenerateFundLevelReportActionStatus: () => dispatch(initGenerateFundLevelReportActionStatus()),

    // Load Fund Level Report
    loadFundLevelReport: (dateString, countryDesc, exchange, fundCode, dataType, qtyType, guid) => dispatch(loadFundLevelReport(dateString, countryDesc, exchange, fundCode, dataType, qtyType, guid)),
    initLoadFundLevelReportActionStatus: () => dispatch(initLoadFundLevelReportActionStatus()),

    // load group info
    listFundPosGroupInfo: (dateString, countryDesc, exchange, fundCode, dataType, qtyType) => dispatch(listFundPosGroupInfo(dateString, countryDesc, exchange, fundCode, dataType, qtyType)),
    initListFundPosGroupInfoActionStatus: () => dispatch(initListFundPosGroupInfoActionStatus()),

    // // Filter Long More Than 2% Fund Level Report
    // filterLongMoreThan2PercentFundLevelReport: () => dispatch(filterLongMoreThan2PercentFundLevelReport()),

    // // Filter Long More Than 5% Fund Level Report
    // filterLongMoreThan5PercentFundLevelReport: () => dispatch(filterLongMoreThan5PercentFundLevelReport()),

    // // Filter Short More Than 2% Fund Level Report
    // filterShortMoreThan2PercentFundLevelReport: () => dispatch(filterShortMoreThan2PercentFundLevelReport()),

    // // Filter Short More Than 5% Fund Level Report
    // filterShortMoreThan5PercentFundLevelReport: () => dispatch(filterShortMoreThan5PercentFundLevelReport()),

    // Show All Fund Level Report
    showAllFundLevelReport: () => dispatch(showAllFundLevelReport()),

    // add grid to container
    fundPositionGroupInfoGridToProps: (grid) => dispatch(fundPositionGroupInfoGridToProps(grid)),
    fundLevelReportGridToProps: (grid) => dispatch(fundLevelReportGridToProps(grid)),

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundLevelReportDashboard);